var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtbShifting(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59464_67301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0339 2.42969H11.5339C10.7515 2.42969 10.1172 2.97334 10.1172 3.64397V6.07254C10.1172 6.74318 10.7515 7.28683 11.5339 7.28683H20.0339C20.8163 7.28683 21.4505 6.74318 21.4505 6.07254V3.64397C21.4505 2.97334 20.8163 2.42969 20.0339 2.42969Z",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4531 4.85938H24.2865C25.0379 4.85938 25.7586 5.15789 26.2899 5.68924C26.8213 6.22059 27.1198 6.94126 27.1198 7.69271V18.0141M13.965 30.3594H7.28646C6.53501 30.3594 5.81434 30.0609 5.28299 29.5295C4.75164 28.9982 4.45313 28.2775 4.45312 27.526V7.69271C4.45312 6.94126 4.75164 6.22059 5.28299 5.68924C5.81434 5.15789 6.53501 4.85938 7.28646 4.85938H10.1198",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1055 20.0078V21.3221",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6328 20.0078C25.6328 21.088 25.6328 21.1147 25.6328 21.1147",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.708 21.2891H18.0275C17.2637 21.2891 16.6445 21.9082 16.6445 22.672V31.6447C16.6445 32.4085 17.2637 33.0277 18.0275 33.0277H27.708C28.4718 33.0277 29.091 32.4085 29.091 31.6447V22.672C29.091 21.9082 28.4718 21.2891 27.708 21.2891Z",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5156 24.5429L19.8505 30.2084M25.5156 24.5429L23.4686 24.5429L22.4451 24.5429M25.5156 24.5429L25.5156 26.5899L25.5156 27.6133",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5703 11.3359H21.856",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5703 15.3828H21.856",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3318 10.5234L9.10565 12.7496L8.09375 11.7377",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3318 14.7734L9.10565 16.9996L8.09375 15.9877",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3318 19.0234L9.10565 21.2496L8.09375 20.2377",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59464_67301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtbShifting);
export default __webpack_public_path__ + "static/media/OtbShifting.64d9d3a31d36375dd8c344f296c491a2.svg";
export { ForwardRef as ReactComponent };